
import React, { useContext } from 'react'
import { useErrorBoundary } from 'react-error-boundary'
import { Button } from 'reactstrap'
import { useNavigate } from 'react-router-dom'

import { SessionContext } from '../../contexts/SessionProvider'

const ErrorFallback = ({ error }) =>
{
	const { resetBoundary } = useErrorBoundary()
	const sessionContext = useContext(SessionContext)
	const navigate = useNavigate()
	
	const handleContinue = () =>
	{
		navigate('/secure' + sessionContext.loginSession.defaultRoute)
		resetBoundary()
	}
	
	return (
		<div className="modal-body">
			<div className="py-3 text-center">
				<h4 className="heading mt-4">
					Something went wrong!
				</h4>
				<p>
					{ error.message }
				</p>
				<p>
					<Button color="info" onClick={ handleContinue }>
						Continue
					</Button>
				</p>
			</div>
		</div>
	)
}

export default ErrorFallback
